var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeCheckboxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.33333C0 2.38781 2.38781 0 5.33333 0H18.6667C21.6122 0 24 2.38781 24 5.33333V18.6667C24 21.6122 21.6122 24 18.6667 24H5.33333C2.38781 24 0 21.6122 0 18.6667V5.33333Z",
    fill: "#FF4524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3956 7.72189C18.8091 8.13538 18.8091 8.80579 18.3956 9.21929L10.6309 16.984C10.2174 17.3975 9.54698 17.3975 9.13348 16.984L5.60407 13.4546C5.19057 13.0411 5.19057 12.3707 5.60407 11.9572C6.01756 11.5437 6.68797 11.5437 7.10147 11.9572L9.88218 14.7379L16.8982 7.72189C17.3117 7.30839 17.9821 7.30839 18.3956 7.72189Z",
    fill: "#FEFEFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheckboxIcon);
export default __webpack_public_path__ + "static/media/orange-checkbox-icon.5e21facfd69ecfe4e91136ba056a2672.svg";
export { ForwardRef as ReactComponent };